/* eslint-disable react/jsx-props-no-spreading */
/* eslint-disable no-nested-ternary */
/* eslint-disable react-hooks/exhaustive-deps */
import {
  Avatar, Flex, Select, Text
} from "@mantine/core";
import React, {
  forwardRef,
  useEffect, useMemo, useRef, useState,
} from "react";
import { useWorkspaceMembers } from "../../hooks/QueryHooks";
import useWorkspaceStore from "../../store/workspace/workspaceStore";

type Props = {
  handleChange: (
    operator: string,
    value: any,
    type: string,
    entityType: string,
    selectedField?: any,
  ) => void;
  fieldSelect: boolean;
  op?: string;
  value?: any;
};

interface ItemProps extends React.ComponentPropsWithoutRef<"div"> {
  avatar_url?: string;
  email?: string;
  name: string;
}

const SelectItem = forwardRef<HTMLDivElement, ItemProps>(
  ({
    avatar_url, email, name, ...others
  }: ItemProps, ref) => (
    <div ref={ref} {...others}>
      <Flex gap={8} align="center" className="overflow-hidden">
        <Avatar src={avatar_url} color="initials" radius="xl" size="sm" name={name} alt={name}>{name ? name[0] : ""}</Avatar>
        <div>
          <Text truncate size="sm" fw={500} lh={1.5}>{name}</Text>
          <Text truncate size="xs" lh={1} opacity={0.65}>
            {email}
          </Text>
        </div>
      </Flex>
    </div>
  ),
);

const MemberFilter = React.memo((props: Props) => {
  const {
    op,
    value,
    handleChange,
    fieldSelect,
  } = props;

  const workspaceId = useWorkspaceStore((state) => state.workspace?.id);

  const { data: workspaceMembers }: any = useWorkspaceMembers({
    workspaceId,
    enabled: !!workspaceId,
    retry: 2,
  });

  const Ops = useMemo(
    () => [
      { value: "eq", label: "is equal to", operator: "eq", id: 1 },
      { value: "ne", label: "is not equal to", operator: "ne", id: 2 },
    ],
    [],
  );
  const [selectOp, setSelectOp] = useState<string | null>(op || null);
  const [selectValue, setSelectValue] = useState<any>(value || "");
  const firstRender = useRef(true);

  const csmList = useMemo(() => workspaceMembers?.users?.map((member: any) => ({
    value: member.user_id,
    label: `${member.first_name} ${member.last_name}`,
    name: `${member.first_name} ${member.last_name}`,
    email: member.email,
    avatar_url: member.avatar_url,
  })) || [], [workspaceMembers?.users?.length]);
  
  useEffect(() => {
    if (!firstRender.current) {
      if (selectOp && selectValue) {
        const operator = Ops.find(item => item.value === selectOp)?.operator || selectOp;
        handleChange(
          operator,
          selectValue,
          "string",
          "column",
        );
      }
    }
    firstRender.current = false;
  }, [selectValue, selectOp]);

  return (
    <>
      <Select
        disabled={fieldSelect}
        placeholder="Select Condition"
        data={Ops}
        value={selectOp}
        onChange={(val) => setSelectOp(val)}
        size="sm"
        w={200}
      />
      <Select
        value={selectValue}
        placeholder="Enter value here"
        onChange={(val) => setSelectValue(val)}
        data={csmList}
        searchable
        w={200}
        maxDropdownHeight={400}
        size="sm"
        selectFirstOptionOnChange={false}
        nothingFoundMessage="Nobody here"
        renderOption={(item: any) => (
          <SelectItem
            key={item.option.value}
            name={item.option.name}
            email={item.option.email}
            avatar_url={item.option.avatar_url}
          />
        )}
      />
    </>
  );
});

export default MemberFilter;
